<template>
    <div class="row main-content" id="top">
        <priceworkflow-sidebar
            :submission="submission"
        ></priceworkflow-sidebar>
        <div class="col-md-10" id="standard-styling" style="padding-left:50px;">
            <div class="h-100 d-flex justify-content-center align-items-center" v-if="isLoading">
                <vue-loaders-ball-beat scale="2" color="black" />
            </div>
            <div v-else>
                <div class="companyInfo">
                    <section>
                        <h2>Current Level Information</h2>
                        <p>
                            <strong>CUSTOMER: </strong>{{ submission.company }} ({{ submission.cust_id }})
                        </p>
                        <p>
                            <strong>PRICE LEVEL: </strong>{{ priceLevel }}
                        </p>
                        <p>
                            <strong>6M SALES: </strong>${{ submission.sales_6m }}
                        </p>
                        <p>
                            <strong>12M SALES: </strong>${{ submission.sales_12m }}
                        </p>
                    </section>
                </div>
                <br>
                <div>
                    <form @submit.prevent="saveCustomDiscount" method="POST">
                        <h2>
                            Custom Discount Information<br>
                            <em id="em-stylings">Fill-out the required information below.</em>
                        </h2>
                        <div>
                            <ul id="horizontal-ul">
                                <li style="padding-left:0;width:33%;">
                                    <span style="color:#cd1b00">*</span> Requested By:<br>
                                    <admin-select v-model="requestedBy" required style="width:90%;">
                                        <option></option>
                                        <option v-for="(userId, name) in priceAuthUsers" :value="userId">{{ name }}</option>
                                    </admin-select>
                                </li>
                                <li style="width:33%;">
                                    <span style="color:#cd1b00;">*</span> Effective Date:
                                    <input v-model="effectiveDate" type="date" style="width:90%;" required />
                                </li>
                                <li style="width:33%;">
                                    <span style="color:#cd1b00;">*</span> Expiration Date:
                                    <input v-model="expirationDate" type="date" style="width:90%;" required />
                                </li>
                            </ul>
                            <ul id="horizontal-ul" style="padding-top:10px;">
                                <li style="width:33%;">
                                    <span style="color:#cd1b00">*</span>% Discount to be Applied:
                                    <input v-model="discountAmount" @input="validateWholeNumber" type="number" style="width:90%;" step="1.00" min="0" required />
                                </li>
                                <li style="width:33%;">
                                    <span style="color:#cd1b00">*</span>Apply Discount To:<br>
                                    <div id="radio-div">
                                        <label>
                                            <input type="radio" v-model="discountType" value="LIST" required>
                                            % Discount Off LIST Price
                                        </label><br>
                                        <label>
                                            <input type="radio" v-model="discountType" value="PRICE LEVEL" required>
                                            % Discount Off Customer's Price Level
                                        </label>
                                    </div>
                                </li>
                                <li style="width:33%;">
                                    <span style="color:#cd1b00">*</span> Business Rationale:<br>
                                    <admin-select v-model="rationale" required style="width:90%;">
                                        <option></option>
                                        <option>Competitive Conversion</option>
                                        <option>Distributor Merge/Acquisition</option>
                                        <option>End-User Conversion</option>
                                        <option>Join Buying Group</option>
                                        <option>Overall Organic Growth</option>
                                        <option>Promo/Show Pricing</option>
                                        <option>Sales Realignment</option>
                                    </admin-select>
                                </li>
                            </ul>
                        </div>
                        <br>
                        <div>
                            <h4>Urgency</h4>
                            <input v-model="urgency" type="checkbox" value="1" />  Is this an Urgent request? If yes, check the box and provide the order number(s) below:<br />
                            <ul class="col-md-10" style="list-style-type:none; display:flex; flex-wrap:wrap; padding-left:0;">
                                <li class="col-md-3" v-for="i in 8" :key="i" style="padding-left:0;">
                                    <input
                                        type="text"
                                        :name="'ord_num['+(i-1)+']'"
                                        class="input"
                                        id="orderNumInputs"
                                        v-model="ordNum[i-1]"
                                        :placeholder="'Order #' + i"
                                    />
                                </li>
                            </ul>
                            <br />
                            Any additional details?<br />
                            <textarea v-model="additionalDetails" style="width:60%;" rows="5"></textarea>
                        </div>
                        <br />
                        <br />
                        <button class="btn-round-red" type="submit">FINISH ></button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

    export default {
        data() {
            return {
                activity: "",
                additionalDetails: null,
                discountAmount: null,
                discountType: "",
                effectiveDate: null,
                expirationDate: null,
                i:8,
                isLoading: true,
                ordNum: ["","","","","","","",""],
                priceAuthUsers: [],
                priceLevel: "",
                rationale: "",
                requestedBy: "",
                submission: {},
                totalSixMonthSales: "",
                totalTwelveMonthSales: "",
                urgency: null,
            }
        },
        props: ['ppId'],
        created() {
            axios.get(`/api/getSubmission/${this.ppId}`).then(response => {
                this.submission = response.data;

                this.activityId = this.submission.activity.id;
                this.activity = this.submission.activity.activity;
                this.discountAmount = this.submission.discount_amount;
                this.discountType = this.submission.discount_type;
                this.priceLevel = this.submission.price_level;
                this.requestedBy = this.submission.requested_by;
                this.rationale = this.submission.rationale;
                this.urgency = this.submission.urgent;
                this.additionalDetails = this.submission.add_details;
                this.effectiveDate = this.submission.eff_date;
                this.expirationDate = this.submission.expiration_date;
                this.totalSixMonthSales = this.submission.sales_6m;
                this.totalTwelveMonthSales = this.submission.sales_12m;

                if(this.submission.ord_num != null) {
                    let ordNums = this.submission.ord_num.split("|");
                    this.ordNum = ordNums;
                }

                this.isLoading = false;
            });
            axios.get(`/api/getPriceAuthUsers`).then(response => {
                this.priceAuthUsers = response.data;
            });
        },
        methods: {
            validateWholeNumber() {
                if(this.discountAmount % 1 !== 0) {
                    this.discountAmount = Math.round(this.discountAmount);
                }
            },
            saveCustomDiscount() {
                let data = {
                    additionalDetails: this.additionalDetails,
                    discountAmount: this.discountAmount,
                    discountType: this.discountType,
                    effectiveDate: this.effectiveDate,
                    expirationDate: this.expirationDate,
                    id: this.submission.id,
                    ordNum: this.ordNum,
                    rationale: this.rationale,
                    requestedBy: this.requestedBy,
                    totalSixMonthSales: this.totalSixMonthSales,
                    totalTwelveMonthSales: this.totalTwelveMonthSales,
                    urgency: this.urgency,
                }

                axios.post('/api/saveCustomDiscountInformation', data).then(response => {
                    this.$router.push({
                        name: "PriceWorkflowDashboards",
                        params: {dashboard: "LevelDeviation"}
                    });
                });
            }
        }
    }
</script>

<style>
    #standard-styling {
        font-family:'acumin-pro-condensed', Helvetica, Arial, sans-serif;
    }

    #em-stylings {
        font-size:.9rem; 
        font-weight:normal; 
        line-height:1.0
    }

    #horizontal-ul {
        list-style-type:none;
        display: flex;
    }

    h4 {
        font-family:'acumin-pro-condensed', Helvetica, Arial, sans-serif;
    }

    #orderNumInputs {
        width: 100%;
        margin-bottom:1rem;
    }

    #radio-div {
        display: flex;
        gap: 10px;
        align-items: center;
        padding-top: 5px;
    }

</style>
